import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveOperations } from '../../procedures/operations/store/operations.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setOperationsQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addOperationsToTimeline } = quickActionsObject
  if (addOperationsToTimeline) {
    yield put(saveOperations())
  }
}

export function* setOperationsQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_OPERATIONS_TO_TIMELINE], setOperationsQuickActionTimeLineRow)
}
